import { render, staticRenderFns } from "./CalendarMonth.vue?vue&type=template&id=01828434&"
import script from "./CalendarMonth.vue?vue&type=script&setup=true&lang=js&"
export * from "./CalendarMonth.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports